import { css } from "@emotion/react";
import { pickAll } from "lodash/fp";
import { useContext } from "react";

import {
  TeaserCard,
  CardContent,
  CardTitle,
  CardMeta,
  Time,
  Button,
  Typography,
  useThemeProps,
  Excerpt,
  handleComponentsProp,
} from "../../wsui/base";

import postsModuleContext from "./postsModuleContext";

const DefaultExcerpt = Excerpt;
const DefaultButton = Button;

export default function PostsModuleTeaserItem(props) {
  props = useThemeProps({ props, name: "MunicipioPostsModuleTeaserItem" });
  let {
    item,
    visibleFields,
    dateFormat = {
      year: "numeric",
      month: "long",
      day: "numeric",
    },
    components = {},
    align,
    ...restProps
  } = props;
  const contentAlign =
    align === "left" || align === "center" || align === "right"
      ? align
      : undefined;
  const contentJustify =
    contentAlign === "right"
      ? "end"
      : contentAlign === "center"
        ? "center"
        : "start";

  let { Button, Excerpt } = handleComponentsProp(components, {
    Button: DefaultButton,
    Excerpt: DefaultExcerpt,
  });

  let link = item.link;
  let cta = link?.title ? link : null;
  link = cta ? null : link;

  item = pickAll(visibleFields, item);

  const { itemColor, excerptLines } = useContext(postsModuleContext);

  return (
    <TeaserCard
      title={item.title}
      link={link}
      color={itemColor}
      image={item.image}
      css={css`
        height: 100%;
      `}
      {...restProps}
    >
      <CardContent
        css={css`
          text-align: ${contentAlign || "start"};
          justify-items: ${contentJustify};
        `}
      >
        <CardTitle variant="h4" align={contentAlign} />
        {item.date && (
          <CardMeta justifyContent={contentJustify}>
            <Time date={item.date} format={dateFormat} />
          </CardMeta>
        )}
        {item.description ? (
          <Excerpt lines={excerptLines}>
            <Typography variant="description" align={contentAlign}>
              {item.description}
            </Typography>
          </Excerpt>
        ) : null}
        {cta ? (
          <Button
            css={css`
              justify-self: ${contentJustify};
            `}
            {...cta}
          />
        ) : null}
      </CardContent>
    </TeaserCard>
  );
}
